/* unplugin-vue-components disabled */import script from "./header-top.vue?vue&type=script&setup=true&lang=js"
export * from "./header-top.vue?vue&type=script&setup=true&lang=js"

import "./header-top.vue?vue&type=style&index=0&id=385dc31b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385dc31b"]])

export default __exports__